export default [
	{
		name: 'uploadConvertData',
		method: 'POST',
		desc: '搜狗数据回传',
		path: '/api/insurance/urlTransService/sogouUploadConvertData'
	},
	{
		name: 'uploadActiveApi',
		method: 'POST',
		desc: '神马数据回传',
		path: '/api/insurance/urlTransService/shenmaUploadActiveApi'
		// path: '/urlTransService/shenmaUploadActiveApi'
	},
	{
		name: 'uploadBaiduApi',
		method: 'POST',
		desc: '百度数据回传',
		path: '/api/insurance/urlTransService/baiDuUploadActiveApi'
		// path: '/urlTransService/shenmaUploadActiveApi'
	},
	{
		name: 'preViewLandingPage',
		method: 'POST',
		desc: '落地页数据',
		path: '/api/insureadmin/cmsPageMeterialManagerService/viewLandingPage'
	},
	{
		name: 'getSemAbTestResult',
		method: 'POST',
		desc: 'ABtest',
		path: '/api/insureadmin/commonService/getSemAbTestResult'
	},
	{
		name: 'redirect',
		method: 'POST',
		desc: 'ABtest',
		path: '/api/insureadmin/landingService/redirect'
	}
];
